import { useCallback, useState } from "react";
import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  Banner,
  BannerList,
  Button,
  PopupDialog,
  PopupDialogTitle,
} from "~/components/design-system/index.js";
import type { DialogProps } from "~/hooks/dialogs/index.js";

export function TrainingDialog({
  open,
  onClose,
}: DialogProps<unknown, unknown>) {
  const { t } = useTranslation();

  const [accepted, setAccepted] = useState(false);

  const handleClose = useCallback(() => {
    // We don't want to allow the user to close the dialog until they accept the terms.
  }, []);

  const handleContinue = useCallback(async () => {
    await onClose(undefined);
  }, [onClose]);

  return (
    <PopupDialog open={open} onClose={handleClose}>
      <PopupDialogTitle
        closeDialog={handleClose}
        titleText={t("training.soad.postSendDialog.title")}
      />
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Banner
          bannerType={BannerList.WARNING}
          body={(t("training.soad.postSendDialog.banner") as string).split(
            "\n",
          )}
        />
        <FormControlLabel
          control={
            <Checkbox value={accepted} onClick={() => setAccepted(!accepted)} />
          }
          label={t("training.soad.postSendDialog.confirmation")}
        />
        <Button
          label={t("buttonLabels.continue")}
          onClick={handleContinue}
          color={"primary"}
          disabled={!accepted}
        />
      </Stack>
    </PopupDialog>
  );
}
